import { render, staticRenderFns } from "./PendingRecipientFilter.vue?vue&type=template&id=64cae7d7"
import script from "./PendingRecipientFilter.vue?vue&type=script&lang=js"
export * from "./PendingRecipientFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports